export default "__VITE_ASSET__CFld27YY__"